<script lang="ts">
  import PreviewControls from "./PreviewControls.view.svelte";
  import { goto } from "$app/navigation";
  import { linkTo } from "$lib/utils/url";

  type previewType = {
    token: string;
    subjectId: string;
    subjectType: number;
    variables: {
      campaignId: string;
    };
  };

  export let preview: previewType;
  const handleClear = () => {
    goto(linkTo("/"), { replaceState: false, invalidateAll: true });
  };
</script>

<PreviewControls
  token={preview?.token}
  subjectType={preview?.subjectType}
  subjectId={preview?.subjectId}
  on:clear={handleClear}
/>
